export default __webpack_public_path__ + "static/media/blackhole2.d287fdc2.webp";